import * as ambassadorWixFaqQuestionEntryV2QuestionEntry from './faq-question-entry-v2-question-entry-question-entry.http.js';
import * as ambassadorWixFaqQuestionEntryV2QuestionEntryTypes from './faq-question-entry-v2-question-entry-question-entry.types.js';
import * as ambassadorWixFaqQuestionEntryV2QuestionEntryUniversalTypes from './faq-question-entry-v2-question-entry-question-entry.universal.js';

export type __PublicMethodMetaInfo<
  K = string,
  M = unknown,
  T = unknown,
  S = unknown,
  Q = unknown,
  R = unknown
> = {
  getUrl: (context: any) => string;
  httpMethod: K;
  path: string;
  pathParams: M;
  __requestType: T;
  __originalRequestType: S;
  __responseType: Q;
  __originalResponseType: R;
};

export function createQuestionEntry(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixFaqQuestionEntryV2QuestionEntryUniversalTypes.CreateQuestionEntryRequest,
  ambassadorWixFaqQuestionEntryV2QuestionEntryTypes.CreateQuestionEntryRequest,
  ambassadorWixFaqQuestionEntryV2QuestionEntryUniversalTypes.CreateQuestionEntryResponse,
  ambassadorWixFaqQuestionEntryV2QuestionEntryTypes.CreateQuestionEntryResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixFaqQuestionEntryV2QuestionEntry.createQuestionEntry(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v2/question-entries',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function getQuestionEntry(): __PublicMethodMetaInfo<
  'GET',
  { questionEntryId: string },
  ambassadorWixFaqQuestionEntryV2QuestionEntryUniversalTypes.GetQuestionEntryRequest,
  ambassadorWixFaqQuestionEntryV2QuestionEntryTypes.GetQuestionEntryRequest,
  ambassadorWixFaqQuestionEntryV2QuestionEntryUniversalTypes.GetQuestionEntryResponse,
  ambassadorWixFaqQuestionEntryV2QuestionEntryTypes.GetQuestionEntryResponse
> {
  const payload = { questionEntryId: ':questionEntryId' } as any;

  const getRequestOptions =
    ambassadorWixFaqQuestionEntryV2QuestionEntry.getQuestionEntry(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'GET',
    path: '/v2/question-entries/{questionEntryId}',
    pathParams: { questionEntryId: 'questionEntryId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function updateQuestionEntry(): __PublicMethodMetaInfo<
  'PATCH',
  { questionEntryId: string },
  ambassadorWixFaqQuestionEntryV2QuestionEntryUniversalTypes.UpdateQuestionEntryRequest,
  ambassadorWixFaqQuestionEntryV2QuestionEntryTypes.UpdateQuestionEntryRequest,
  ambassadorWixFaqQuestionEntryV2QuestionEntryUniversalTypes.UpdateQuestionEntryResponse,
  ambassadorWixFaqQuestionEntryV2QuestionEntryTypes.UpdateQuestionEntryResponse
> {
  const payload = { questionEntry: { id: ':questionEntryId' } } as any;

  const getRequestOptions =
    ambassadorWixFaqQuestionEntryV2QuestionEntry.updateQuestionEntry(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'PATCH',
    path: '/v2/question-entries/{questionEntry.id}',
    pathParams: { questionEntryId: 'questionEntryId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function deleteQuestionEntry(): __PublicMethodMetaInfo<
  'DELETE',
  { questionEntryId: string },
  ambassadorWixFaqQuestionEntryV2QuestionEntryUniversalTypes.DeleteQuestionEntryRequest,
  ambassadorWixFaqQuestionEntryV2QuestionEntryTypes.DeleteQuestionEntryRequest,
  ambassadorWixFaqQuestionEntryV2QuestionEntryUniversalTypes.DeleteQuestionEntryResponse,
  ambassadorWixFaqQuestionEntryV2QuestionEntryTypes.DeleteQuestionEntryResponse
> {
  const payload = { questionEntryId: ':questionEntryId' } as any;

  const getRequestOptions =
    ambassadorWixFaqQuestionEntryV2QuestionEntry.deleteQuestionEntry(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'DELETE',
    path: '/v2/question-entries/{questionEntryId}',
    pathParams: { questionEntryId: 'questionEntryId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function listQuestionEntries(): __PublicMethodMetaInfo<
  'GET',
  {},
  ambassadorWixFaqQuestionEntryV2QuestionEntryUniversalTypes.ListQuestionEntriesRequest,
  ambassadorWixFaqQuestionEntryV2QuestionEntryTypes.ListQuestionEntriesRequest,
  ambassadorWixFaqQuestionEntryV2QuestionEntryUniversalTypes.ListQuestionEntriesResponse,
  ambassadorWixFaqQuestionEntryV2QuestionEntryTypes.ListQuestionEntriesResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixFaqQuestionEntryV2QuestionEntry.listQuestionEntries(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'GET',
    path: '/v2/question-entries',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function queryQuestionEntries(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixFaqQuestionEntryV2QuestionEntryUniversalTypes.QueryQuestionEntriesRequest,
  ambassadorWixFaqQuestionEntryV2QuestionEntryTypes.QueryQuestionEntriesRequest,
  ambassadorWixFaqQuestionEntryV2QuestionEntryUniversalTypes.QueryQuestionEntriesResponse,
  ambassadorWixFaqQuestionEntryV2QuestionEntryTypes.QueryQuestionEntriesResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixFaqQuestionEntryV2QuestionEntry.queryQuestionEntries(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v2/question-entries/query',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function bulkDeleteQuestionEntries(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixFaqQuestionEntryV2QuestionEntryUniversalTypes.BulkDeleteQuestionEntriesRequest,
  ambassadorWixFaqQuestionEntryV2QuestionEntryTypes.BulkDeleteQuestionEntriesRequest,
  ambassadorWixFaqQuestionEntryV2QuestionEntryUniversalTypes.BulkDeleteQuestionEntriesResponse,
  ambassadorWixFaqQuestionEntryV2QuestionEntryTypes.BulkDeleteQuestionEntriesResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixFaqQuestionEntryV2QuestionEntry.bulkDeleteQuestionEntries(
      payload
    );

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v2/bulk/question-entries/delete',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function updateExtendedFields(): __PublicMethodMetaInfo<
  'POST',
  { id: string },
  ambassadorWixFaqQuestionEntryV2QuestionEntryUniversalTypes.UpdateExtendedFieldsRequest,
  ambassadorWixFaqQuestionEntryV2QuestionEntryTypes.UpdateExtendedFieldsRequest,
  ambassadorWixFaqQuestionEntryV2QuestionEntryUniversalTypes.UpdateExtendedFieldsResponse,
  ambassadorWixFaqQuestionEntryV2QuestionEntryTypes.UpdateExtendedFieldsResponse
> {
  const payload = { id: ':id' } as any;

  const getRequestOptions =
    ambassadorWixFaqQuestionEntryV2QuestionEntry.updateExtendedFields(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v2/question-entries/{id}/update-extended-fields',
    pathParams: { id: 'id' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function setQuestionEntryLabels(): __PublicMethodMetaInfo<
  'PATCH',
  { questionEntryId: string },
  ambassadorWixFaqQuestionEntryV2QuestionEntryUniversalTypes.SetQuestionEntryLabelsRequest,
  ambassadorWixFaqQuestionEntryV2QuestionEntryTypes.SetQuestionEntryLabelsRequest,
  ambassadorWixFaqQuestionEntryV2QuestionEntryUniversalTypes.SetQuestionEntryLabelsResponse,
  ambassadorWixFaqQuestionEntryV2QuestionEntryTypes.SetQuestionEntryLabelsResponse
> {
  const payload = { questionEntryId: ':questionEntryId' } as any;

  const getRequestOptions =
    ambassadorWixFaqQuestionEntryV2QuestionEntry.setQuestionEntryLabels(
      payload
    );

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'PATCH',
    path: '/v2/question-entries/{questionEntryId}/labels',
    pathParams: { questionEntryId: 'questionEntryId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function bulkUpdateQuestionEntry(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixFaqQuestionEntryV2QuestionEntryUniversalTypes.BulkUpdateQuestionEntryRequest,
  ambassadorWixFaqQuestionEntryV2QuestionEntryTypes.BulkUpdateQuestionEntryRequest,
  ambassadorWixFaqQuestionEntryV2QuestionEntryUniversalTypes.BulkUpdateQuestionEntryResponse,
  ambassadorWixFaqQuestionEntryV2QuestionEntryTypes.BulkUpdateQuestionEntryResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixFaqQuestionEntryV2QuestionEntry.bulkUpdateQuestionEntry(
      payload
    );

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v2/bulk/question-entries/update',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export {
  QuestionEntry as QuestionEntryOriginal,
  QuestionEntryAnswerOneOf as QuestionEntryAnswerOneOfOriginal,
  RichContent as RichContentOriginal,
  Node as NodeOriginal,
  NodeDataOneOf as NodeDataOneOfOriginal,
  NodeType as NodeTypeOriginal,
  NodeTypeWithLiterals as NodeTypeWithLiteralsOriginal,
  NodeStyle as NodeStyleOriginal,
  ButtonData as ButtonDataOriginal,
  BackgroundType as BackgroundTypeOriginal,
  BackgroundTypeWithLiterals as BackgroundTypeWithLiteralsOriginal,
  Gradient as GradientOriginal,
  GradientType as GradientTypeOriginal,
  GradientTypeWithLiterals as GradientTypeWithLiteralsOriginal,
  Stop as StopOriginal,
  Border as BorderOriginal,
  Colors as ColorsOriginal,
  Background as BackgroundOriginal,
  PluginContainerData as PluginContainerDataOriginal,
  WidthType as WidthTypeOriginal,
  WidthTypeWithLiterals as WidthTypeWithLiteralsOriginal,
  PluginContainerDataWidth as PluginContainerDataWidthOriginal,
  PluginContainerDataWidthDataOneOf as PluginContainerDataWidthDataOneOfOriginal,
  PluginContainerDataAlignment as PluginContainerDataAlignmentOriginal,
  PluginContainerDataAlignmentWithLiterals as PluginContainerDataAlignmentWithLiteralsOriginal,
  Spoiler as SpoilerOriginal,
  Height as HeightOriginal,
  ButtonDataType as ButtonDataTypeOriginal,
  ButtonDataTypeWithLiterals as ButtonDataTypeWithLiteralsOriginal,
  Styles as StylesOriginal,
  Link as LinkOriginal,
  LinkDataOneOf as LinkDataOneOfOriginal,
  Target as TargetOriginal,
  TargetWithLiterals as TargetWithLiteralsOriginal,
  Rel as RelOriginal,
  Animation as AnimationOriginal,
  Type as TypeOriginal,
  TypeWithLiterals as TypeWithLiteralsOriginal,
  EntranceAnimation as EntranceAnimationOriginal,
  EntranceEffect as EntranceEffectOriginal,
  EntranceEffectType as EntranceEffectTypeOriginal,
  EntranceEffectTypeWithLiterals as EntranceEffectTypeWithLiteralsOriginal,
  LoopAnimation as LoopAnimationOriginal,
  LoopEffect as LoopEffectOriginal,
  LoopEffectType as LoopEffectTypeOriginal,
  LoopEffectTypeWithLiterals as LoopEffectTypeWithLiteralsOriginal,
  PointerEffect as PointerEffectOriginal,
  PointerEffectType as PointerEffectTypeOriginal,
  PointerEffectTypeWithLiterals as PointerEffectTypeWithLiteralsOriginal,
  CodeBlockData as CodeBlockDataOriginal,
  TextStyle as TextStyleOriginal,
  TextAlignment as TextAlignmentOriginal,
  TextAlignmentWithLiterals as TextAlignmentWithLiteralsOriginal,
  DividerData as DividerDataOriginal,
  LineCap as LineCapOriginal,
  LineCapWithLiterals as LineCapWithLiteralsOriginal,
  LineStyle as LineStyleOriginal,
  LineStyleWithLiterals as LineStyleWithLiteralsOriginal,
  Width as WidthOriginal,
  WidthWithLiterals as WidthWithLiteralsOriginal,
  DividerDataAlignment as DividerDataAlignmentOriginal,
  DividerDataAlignmentWithLiterals as DividerDataAlignmentWithLiteralsOriginal,
  DividerDataStyles as DividerDataStylesOriginal,
  FileData as FileDataOriginal,
  ViewMode as ViewModeOriginal,
  ViewModeWithLiterals as ViewModeWithLiteralsOriginal,
  FileSource as FileSourceOriginal,
  FileSourceDataOneOf as FileSourceDataOneOfOriginal,
  PDFSettings as PDFSettingsOriginal,
  GalleryData as GalleryDataOriginal,
  Media as MediaOriginal,
  Image as ImageOriginal,
  Video as VideoOriginal,
  Item as ItemOriginal,
  ItemDataOneOf as ItemDataOneOfOriginal,
  GalleryOptions as GalleryOptionsOriginal,
  LayoutType as LayoutTypeOriginal,
  LayoutTypeWithLiterals as LayoutTypeWithLiteralsOriginal,
  Orientation as OrientationOriginal,
  OrientationWithLiterals as OrientationWithLiteralsOriginal,
  Crop as CropOriginal,
  CropWithLiterals as CropWithLiteralsOriginal,
  ThumbnailsAlignment as ThumbnailsAlignmentOriginal,
  ThumbnailsAlignmentWithLiterals as ThumbnailsAlignmentWithLiteralsOriginal,
  GalleryOptionsLayout as GalleryOptionsLayoutOriginal,
  ItemStyle as ItemStyleOriginal,
  Thumbnails as ThumbnailsOriginal,
  GIFData as GIFDataOriginal,
  GIF as GIFOriginal,
  GIFType as GIFTypeOriginal,
  GIFTypeWithLiterals as GIFTypeWithLiteralsOriginal,
  HeadingData as HeadingDataOriginal,
  HTMLData as HTMLDataOriginal,
  HTMLDataDataOneOf as HTMLDataDataOneOfOriginal,
  Source as SourceOriginal,
  SourceWithLiterals as SourceWithLiteralsOriginal,
  ImageData as ImageDataOriginal,
  StylesBorder as StylesBorderOriginal,
  ImageDataStyles as ImageDataStylesOriginal,
  ImageDataCrop as ImageDataCropOriginal,
  LinkPreviewData as LinkPreviewDataOriginal,
  StylesPosition as StylesPositionOriginal,
  StylesPositionWithLiterals as StylesPositionWithLiteralsOriginal,
  LinkPreviewDataStyles as LinkPreviewDataStylesOriginal,
  MapData as MapDataOriginal,
  MapSettings as MapSettingsOriginal,
  MapType as MapTypeOriginal,
  MapTypeWithLiterals as MapTypeWithLiteralsOriginal,
  ParagraphData as ParagraphDataOriginal,
  PollData as PollDataOriginal,
  ViewRole as ViewRoleOriginal,
  ViewRoleWithLiterals as ViewRoleWithLiteralsOriginal,
  VoteRole as VoteRoleOriginal,
  VoteRoleWithLiterals as VoteRoleWithLiteralsOriginal,
  Permissions as PermissionsOriginal,
  Option as OptionOriginal,
  Settings as SettingsOriginal,
  PollLayoutType as PollLayoutTypeOriginal,
  PollLayoutTypeWithLiterals as PollLayoutTypeWithLiteralsOriginal,
  PollLayoutDirection as PollLayoutDirectionOriginal,
  PollLayoutDirectionWithLiterals as PollLayoutDirectionWithLiteralsOriginal,
  PollLayout as PollLayoutOriginal,
  OptionLayout as OptionLayoutOriginal,
  PollDesignBackgroundType as PollDesignBackgroundTypeOriginal,
  PollDesignBackgroundTypeWithLiterals as PollDesignBackgroundTypeWithLiteralsOriginal,
  BackgroundGradient as BackgroundGradientOriginal,
  PollDesignBackground as PollDesignBackgroundOriginal,
  PollDesignBackgroundBackgroundOneOf as PollDesignBackgroundBackgroundOneOfOriginal,
  PollDesign as PollDesignOriginal,
  OptionDesign as OptionDesignOriginal,
  Poll as PollOriginal,
  PollDataLayout as PollDataLayoutOriginal,
  Design as DesignOriginal,
  TextData as TextDataOriginal,
  Decoration as DecorationOriginal,
  DecorationDataOneOf as DecorationDataOneOfOriginal,
  DecorationType as DecorationTypeOriginal,
  DecorationTypeWithLiterals as DecorationTypeWithLiteralsOriginal,
  AnchorData as AnchorDataOriginal,
  ColorData as ColorDataOriginal,
  ColorDataBackgroundType as ColorDataBackgroundTypeOriginal,
  ColorDataBackgroundTypeWithLiterals as ColorDataBackgroundTypeWithLiteralsOriginal,
  ColorDataBackground as ColorDataBackgroundOriginal,
  LinkData as LinkDataOriginal,
  MentionData as MentionDataOriginal,
  FontSizeData as FontSizeDataOriginal,
  FontType as FontTypeOriginal,
  FontTypeWithLiterals as FontTypeWithLiteralsOriginal,
  SpoilerData as SpoilerDataOriginal,
  FontFamilyData as FontFamilyDataOriginal,
  SketchData as SketchDataOriginal,
  Variant as VariantOriginal,
  VariantWithLiterals as VariantWithLiteralsOriginal,
  AppEmbedData as AppEmbedDataOriginal,
  AppEmbedDataAppDataOneOf as AppEmbedDataAppDataOneOfOriginal,
  Position as PositionOriginal,
  PositionWithLiterals as PositionWithLiteralsOriginal,
  AspectRatio as AspectRatioOriginal,
  AspectRatioWithLiterals as AspectRatioWithLiteralsOriginal,
  Resizing as ResizingOriginal,
  ResizingWithLiterals as ResizingWithLiteralsOriginal,
  Placement as PlacementOriginal,
  PlacementWithLiterals as PlacementWithLiteralsOriginal,
  CardStylesType as CardStylesTypeOriginal,
  CardStylesTypeWithLiterals as CardStylesTypeWithLiteralsOriginal,
  Alignment as AlignmentOriginal,
  AlignmentWithLiterals as AlignmentWithLiteralsOriginal,
  Layout as LayoutOriginal,
  LayoutWithLiterals as LayoutWithLiteralsOriginal,
  AppType as AppTypeOriginal,
  AppTypeWithLiterals as AppTypeWithLiteralsOriginal,
  BookingData as BookingDataOriginal,
  EventData as EventDataOriginal,
  ButtonStyles as ButtonStylesOriginal,
  ImageStyles as ImageStylesOriginal,
  RibbonStyles as RibbonStylesOriginal,
  CardStyles as CardStylesOriginal,
  PricingData as PricingDataOriginal,
  VideoData as VideoDataOriginal,
  PlaybackOptions as PlaybackOptionsOriginal,
  EmbedData as EmbedDataOriginal,
  Oembed as OembedOriginal,
  CollapsibleListData as CollapsibleListDataOriginal,
  InitialExpandedItems as InitialExpandedItemsOriginal,
  InitialExpandedItemsWithLiterals as InitialExpandedItemsWithLiteralsOriginal,
  Direction as DirectionOriginal,
  DirectionWithLiterals as DirectionWithLiteralsOriginal,
  TableData as TableDataOriginal,
  Dimensions as DimensionsOriginal,
  TableCellData as TableCellDataOriginal,
  VerticalAlignment as VerticalAlignmentOriginal,
  VerticalAlignmentWithLiterals as VerticalAlignmentWithLiteralsOriginal,
  CellStyle as CellStyleOriginal,
  BorderColors as BorderColorsOriginal,
  BorderWidths as BorderWidthsOriginal,
  NullValue as NullValueOriginal,
  NullValueWithLiterals as NullValueWithLiteralsOriginal,
  ListValue as ListValueOriginal,
  AudioData as AudioDataOriginal,
  OrderedListData as OrderedListDataOriginal,
  BulletedListData as BulletedListDataOriginal,
  BlockquoteData as BlockquoteDataOriginal,
  CaptionData as CaptionDataOriginal,
  LayoutData as LayoutDataOriginal,
  ImageScalingScaling as ImageScalingScalingOriginal,
  ImageScalingScalingWithLiterals as ImageScalingScalingWithLiteralsOriginal,
  ImagePosition as ImagePositionOriginal,
  ImagePositionWithLiterals as ImagePositionWithLiteralsOriginal,
  LayoutDataBackground as LayoutDataBackgroundOriginal,
  LayoutDataBackgroundType as LayoutDataBackgroundTypeOriginal,
  LayoutDataBackgroundTypeWithLiterals as LayoutDataBackgroundTypeWithLiteralsOriginal,
  Origin as OriginOriginal,
  OriginWithLiterals as OriginWithLiteralsOriginal,
  BannerPosition as BannerPositionOriginal,
  BannerPositionWithLiterals as BannerPositionWithLiteralsOriginal,
  LayerEffect as LayerEffectOriginal,
  LayerEffectWithLiterals as LayerEffectWithLiteralsOriginal,
  Shape as ShapeOriginal,
  ShapeWithLiterals as ShapeWithLiteralsOriginal,
  Layers as LayersOriginal,
  BackdropType as BackdropTypeOriginal,
  BackdropTypeWithLiterals as BackdropTypeWithLiteralsOriginal,
  LayoutDataBackgroundImage as LayoutDataBackgroundImageOriginal,
  VerticalAlignmentAlignment as VerticalAlignmentAlignmentOriginal,
  VerticalAlignmentAlignmentWithLiterals as VerticalAlignmentAlignmentWithLiteralsOriginal,
  ResponsivenessBehaviour as ResponsivenessBehaviourOriginal,
  ResponsivenessBehaviourWithLiterals as ResponsivenessBehaviourWithLiteralsOriginal,
  DesignTarget as DesignTargetOriginal,
  DesignTargetWithLiterals as DesignTargetWithLiteralsOriginal,
  Banner as BannerOriginal,
  Backdrop as BackdropOriginal,
  SectionDivider as SectionDividerOriginal,
  LayoutCellData as LayoutCellDataOriginal,
  ShapeData as ShapeDataOriginal,
  ShapeDataStyles as ShapeDataStylesOriginal,
  CardData as CardDataOriginal,
  Scaling as ScalingOriginal,
  ScalingWithLiterals as ScalingWithLiteralsOriginal,
  ImagePositionPosition as ImagePositionPositionOriginal,
  ImagePositionPositionWithLiterals as ImagePositionPositionWithLiteralsOriginal,
  CardDataBackground as CardDataBackgroundOriginal,
  CardDataBackgroundType as CardDataBackgroundTypeOriginal,
  CardDataBackgroundTypeWithLiterals as CardDataBackgroundTypeWithLiteralsOriginal,
  BackgroundImage as BackgroundImageOriginal,
  TocData as TocDataOriginal,
  ListStyle as ListStyleOriginal,
  ListStyleWithLiterals as ListStyleWithLiteralsOriginal,
  Indentation as IndentationOriginal,
  IndentationWithLiterals as IndentationWithLiteralsOriginal,
  SmartBlockData as SmartBlockDataOriginal,
  SmartBlockDataType as SmartBlockDataTypeOriginal,
  SmartBlockDataTypeWithLiterals as SmartBlockDataTypeWithLiteralsOriginal,
  ColumnSize as ColumnSizeOriginal,
  ColumnSizeWithLiterals as ColumnSizeWithLiteralsOriginal,
  SmartBlockCellData as SmartBlockCellDataOriginal,
  CheckboxListData as CheckboxListDataOriginal,
  ListItemNodeData as ListItemNodeDataOriginal,
  SlotData as SlotDataOriginal,
  SlotDesign as SlotDesignOriginal,
  Metadata as MetadataOriginal,
  DocumentStyle as DocumentStyleOriginal,
  TextNodeStyle as TextNodeStyleOriginal,
  Label as LabelOriginal,
  QuestionStatus as QuestionStatusOriginal,
  QuestionStatusWithLiterals as QuestionStatusWithLiteralsOriginal,
  ExtendedFields as ExtendedFieldsOriginal,
  CreateQuestionEntryRequest as CreateQuestionEntryRequestOriginal,
  CreateQuestionEntryResponse as CreateQuestionEntryResponseOriginal,
  GetQuestionEntryRequest as GetQuestionEntryRequestOriginal,
  GetQuestionEntryResponse as GetQuestionEntryResponseOriginal,
  UpdateQuestionEntryRequest as UpdateQuestionEntryRequestOriginal,
  UpdateQuestionEntryResponse as UpdateQuestionEntryResponseOriginal,
  DeleteQuestionEntryRequest as DeleteQuestionEntryRequestOriginal,
  DeleteQuestionEntryResponse as DeleteQuestionEntryResponseOriginal,
  ListQuestionEntriesRequest as ListQuestionEntriesRequestOriginal,
  CursorPaging as CursorPagingOriginal,
  ContentFormat as ContentFormatOriginal,
  ContentFormatWithLiterals as ContentFormatWithLiteralsOriginal,
  FieldSet as FieldSetOriginal,
  FieldSetWithLiterals as FieldSetWithLiteralsOriginal,
  ListQuestionEntriesResponse as ListQuestionEntriesResponseOriginal,
  PagingMetadataV2 as PagingMetadataV2Original,
  Cursors as CursorsOriginal,
  QueryQuestionEntriesRequest as QueryQuestionEntriesRequestOriginal,
  CursorQuery as CursorQueryOriginal,
  CursorQueryPagingMethodOneOf as CursorQueryPagingMethodOneOfOriginal,
  Sorting as SortingOriginal,
  SortOrder as SortOrderOriginal,
  SortOrderWithLiterals as SortOrderWithLiteralsOriginal,
  AddressLocation as AddressLocationOriginal,
  QueryQuestionEntriesRequestContentFormat as QueryQuestionEntriesRequestContentFormatOriginal,
  QueryQuestionEntriesRequestContentFormatWithLiterals as QueryQuestionEntriesRequestContentFormatWithLiteralsOriginal,
  QueryQuestionEntriesRequestFieldSet as QueryQuestionEntriesRequestFieldSetOriginal,
  QueryQuestionEntriesRequestFieldSetWithLiterals as QueryQuestionEntriesRequestFieldSetWithLiteralsOriginal,
  QueryQuestionEntriesResponse as QueryQuestionEntriesResponseOriginal,
  CursorPagingMetadata as CursorPagingMetadataOriginal,
  BulkDeleteQuestionEntriesRequest as BulkDeleteQuestionEntriesRequestOriginal,
  BulkDeleteQuestionEntriesResponse as BulkDeleteQuestionEntriesResponseOriginal,
  ItemMetadata as ItemMetadataOriginal,
  ApplicationError as ApplicationErrorOriginal,
  BulkActionMetadata as BulkActionMetadataOriginal,
  UpdateExtendedFieldsRequest as UpdateExtendedFieldsRequestOriginal,
  UpdateExtendedFieldsResponse as UpdateExtendedFieldsResponseOriginal,
  SetQuestionEntryLabelsRequest as SetQuestionEntryLabelsRequestOriginal,
  SetQuestionEntryLabelsResponse as SetQuestionEntryLabelsResponseOriginal,
  BulkUpdateQuestionEntryRequest as BulkUpdateQuestionEntryRequestOriginal,
  MaskedQuestionEntry as MaskedQuestionEntryOriginal,
  BulkUpdateQuestionEntryResponse as BulkUpdateQuestionEntryResponseOriginal,
  BulkUpdateQuestionEntryResult as BulkUpdateQuestionEntryResultOriginal,
  DomainEvent as DomainEventOriginal,
  DomainEventBodyOneOf as DomainEventBodyOneOfOriginal,
  EntityCreatedEvent as EntityCreatedEventOriginal,
  RestoreInfo as RestoreInfoOriginal,
  EntityUpdatedEvent as EntityUpdatedEventOriginal,
  EntityDeletedEvent as EntityDeletedEventOriginal,
  ActionEvent as ActionEventOriginal,
  Empty as EmptyOriginal,
  MetaSiteSpecialEvent as MetaSiteSpecialEventOriginal,
  MetaSiteSpecialEventPayloadOneOf as MetaSiteSpecialEventPayloadOneOfOriginal,
  Asset as AssetOriginal,
  State as StateOriginal,
  StateWithLiterals as StateWithLiteralsOriginal,
  SiteCreated as SiteCreatedOriginal,
  SiteCreatedContext as SiteCreatedContextOriginal,
  SiteCreatedContextWithLiterals as SiteCreatedContextWithLiteralsOriginal,
  Namespace as NamespaceOriginal,
  NamespaceWithLiterals as NamespaceWithLiteralsOriginal,
  SiteTransferred as SiteTransferredOriginal,
  SiteDeleted as SiteDeletedOriginal,
  DeleteContext as DeleteContextOriginal,
  DeleteStatus as DeleteStatusOriginal,
  DeleteStatusWithLiterals as DeleteStatusWithLiteralsOriginal,
  SiteUndeleted as SiteUndeletedOriginal,
  SitePublished as SitePublishedOriginal,
  SiteUnpublished as SiteUnpublishedOriginal,
  SiteMarkedAsTemplate as SiteMarkedAsTemplateOriginal,
  SiteMarkedAsWixSite as SiteMarkedAsWixSiteOriginal,
  ServiceProvisioned as ServiceProvisionedOriginal,
  ServiceRemoved as ServiceRemovedOriginal,
  SiteRenamed as SiteRenamedOriginal,
  SiteHardDeleted as SiteHardDeletedOriginal,
  NamespaceChanged as NamespaceChangedOriginal,
  StudioAssigned as StudioAssignedOriginal,
  StudioUnassigned as StudioUnassignedOriginal,
  SiteUrlChanged as SiteUrlChangedOriginal,
  SitePurgedExternally as SitePurgedExternallyOriginal,
  OdeditorAssigned as OdeditorAssignedOriginal,
  OdeditorUnassigned as OdeditorUnassignedOriginal,
  PicassoAssigned as PicassoAssignedOriginal,
  PicassoUnassigned as PicassoUnassignedOriginal,
  WixelAssigned as WixelAssignedOriginal,
  WixelUnassigned as WixelUnassignedOriginal,
  StudioTwoAssigned as StudioTwoAssignedOriginal,
  StudioTwoUnassigned as StudioTwoUnassignedOriginal,
  UserDomainMediaEnabled as UserDomainMediaEnabledOriginal,
  UserDomainMediaDisabled as UserDomainMediaDisabledOriginal,
  EditorlessAssigned as EditorlessAssignedOriginal,
  EditorlessUnassigned as EditorlessUnassignedOriginal,
  RunInstallationContentRequest as RunInstallationContentRequestOriginal,
  RunInstallationContentResponse as RunInstallationContentResponseOriginal,
  MessageEnvelope as MessageEnvelopeOriginal,
  IdentificationData as IdentificationDataOriginal,
  IdentificationDataIdOneOf as IdentificationDataIdOneOfOriginal,
  WebhookIdentityType as WebhookIdentityTypeOriginal,
  WebhookIdentityTypeWithLiterals as WebhookIdentityTypeWithLiteralsOriginal,
  AccountInfo as AccountInfoOriginal,
} from './faq-question-entry-v2-question-entry-question-entry.types.js';
